module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-2",
      "lang": "en-US"
    }
  }, [_vm._v("Two")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("B")]), _vm._v("y the glow of the sinking fire, Clea watched the wizard as he slept.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Remembered what she had heard, of what he had done.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Since first he’d come to the Twilight Lands of the West—trained in the arts of the Brown Mages of Telmayre—he had hated the merchant lords of the Marble City of Dey Allias, they said: hated the city itself. The mages had come first from the Bright Island, and had been welcomed by the nations that dwelt in the coastal fogs and the endless forests of the Mire: the Ashupik, the Lhogri, the Placne, the Setuket, the hundreds of lesser kinships allied with them. The native shamans had welcomed their wisdom, and the local Darklander clan lords had been glad of the trade that came after them. The mages had taught the Darklander farmers more efficient ways of bringing food from the land, and the Darklander healers stronger and better magics. Those who mistrusted and rejected the tall strangers from over the sea were defeated by the weapons of the newcomers, forged of adamine, the blacksteel that held stronger spells of destruction, of strength, of victory than any Darklander mage could lay on ordinary iron or steel.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Long before Ithrazel came from Telmayre, men of his islands had discovered adamis in the river-sands. The Emperor of Light in Esselmyriel had given the merchant houses “concessions” in the Twilight Lands to dredge adamis, first from the river-sands, then years later, from the endless miles of flooded canyons that made up the Mire, inland beyond the western hills. The streets of the Marble City had blazed with the fruits of the wealth being drawn from the land, mostly by Darklander labor: shops crammed with silk, with silver, with cunning works in leather and glass. Wharves jostling with ships, warehouses stuffed with wheat and hides from the farms that stretched up and down the coast—not that any Telmayrian ever turned soil with his own hands.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Warehouses stuffed with adamine.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And the mages, whose coming had begun it all, all had Houses there: the Brown Mages in a compound beyond the North Harbor, the Black Mages in a painted basilica near the river-mouth keeping their hands carefully clean of the affairs of either the Telmayrians or the Darklander clans; the Red Mages among the palaces of the rich. By the South Harbor had stood the House of Glass, beautiful and amazing and shimmering like a jewel, where the New Order, the Crystal Mages, had established themselves only a dozen years before the destruction of the city, startling the ancient orders with the strength of their spells, the rapidity and depth of their learning.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Even in the deeps of night, the stories said, Dey Allias had glimmered like a lake of jewels, a bed of embers, illuminated windows like twenty thousand topazes in the darkness. Torches burned before the temples of the gods, brighter than rubies and citrines.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It had been night when Ithrazel had destroyed the city.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Archmage of the Brown Order, he had called the domination of the Lords of Telmayre over the Darklanders slavery and denounced Dey Allias as a cesspit of oppression, of power misused and justice twisted. Even the gods, he had cried, must hate the stink of the place.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He took a small group of renegade mages out of the city only days before sickness broke out there, a plague that the other Orders—and both Sisterhoods—struggled in vain to cure. And on a midsummer night, seventy-five years ago, he and his followers had returned to the Hill of Oleanders outside the city and formed a vast sigil that had glowed—said the hill-shepherds who had seen it—in a misty light. Their small forms, hard and dark, had moved through that light, raising their hands, calling down their curse …")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He woke screaming “NO!!!” and the pain that went through him, like hot knives as his muscles convulsed, was a thousand times worse than the claws of the birds. He was weeping as hard, slim hands gripped his arms, and fought to turn away from Clea’s shoulder—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He thrust her aside, horror wrenching him until he thought he must be physically crushed by it, physically twisted to pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Hearing them scream, every one of them, as the city went up in flames.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The air was gray now. The hollow in the rocks smelled of campfire smoke. Clea backed away from him, and for a time he could only huddle where he lay, his head buried in his arms, weeping, and waiting for the grip of the dream to slacken.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It left him shaking, like a physical purge.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In time he thought"), _c('span', {
    staticClass: "ital"
  }, [_vm._v(", the birds will be coming soon")]), _vm._v(" …")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He heard Clea’s boots scrunch in the sand, the creak of boot-leather and the scent of her doublet as she squatted beside him again. “Can I help?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You can go to hell.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He heard her drop something—cloth—on the ground beside him. “Can you eat?” she asked, in another tone, and walked away, back to the fire. “We have to get going, if we’re going to reach the Corridor of Mirrors back to the real world.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Ithrazel sat up and flexed his hands. It had been a long time since he’d seen them really: square, strong, with short, powerful fingers. His beard and his fine-textured hair were barely stubble. "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Did they re-make themselves—like my fingernails?—every night when I healed")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("?")]), _vm._v(" The pain of healing was almost gone.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He pulled on the coarse shirt she’d left beside him, the peasant breeches and boots. “"), _c('span', {
    staticClass: "ital"
  }, [_vm._v("You’re")]), _vm._v(" going to reach the Corridor of Mirrors,” he corrected her. “I’ll be staying here, thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Hamo the shepherd, sitting on the other side of the fire, glanced nervously from Clea to Ithrazel. “The birds …” There was something in his doglike gaze that made the old mage want to go over and slap Clea. "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The damn girl’s put a love-spell on him, to make sure he’ll do as she bids him")]), _vm._v(" … "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Or had her White Sister friend do it.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’m sorry.” Clea walked over to Ithrazel—now that he was on his feet again, he saw that slight as she was, she was tall, his own moderate height. She took his wrist, where the shackle of his chain was still locked around it, touched the sigils that traced the incorruptible blacksteel. “We need you and you have to come. I’m guessing the chains they put on you keep you from doing magic.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He jerked his hand from her. “Or it’s just this world. Or the spells they laid on me—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Can you do magic now?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He couldn’t. He knew it in his bone-marrow.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Hamo startled, looked skyward as a shadow passed over them.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Damn rotten filthy hell-chickens")]), _vm._v(" …")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Let’s go.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Typical arrogant Telmayrian bitch")]), _vm._v(" …")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leaving the blankets where they were, Clea scooped up the water-bottles and the remains of a satchel of bread and cheese and handed them to Hamo. Slipped her blacksteel sword from its sheath with a deadly metallic whisper, and led the way down the gorge.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("I may be Telmayrian myself but I NEVER behaved like that. Well, not after I’d been in the Twilight Lands for a couple of weeks")]), _vm._v(" … "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("or a season")]), _vm._v(" …")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She didn’t even look back to see if he were following.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Serve her right if I just dodged into the brush")]), _vm._v(" …")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Only of course the presence of thirty or so swooping, screaming, flesh-tearing eagles and vultures would probably give me away.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Hamo glanced back repeatedly to see if he was following. Ithrazel couldn’t make up his mind whether that was better or worse than Clea’s blithe assumption that he’d obey her, but it felt good beyond anything he’d ever imagined was possible to be walking again, birds or no birds.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Do you need a stick?” she called back over her shoulder as they reached the end of the gorge, where it dropped off into another sickening scarp of bare rock.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, I don’t need a stick! I’m not in my dotage!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She stood aside, sword in hand, to let Hamo and Ithrazel precede her down the hair-raising goat-trail that led down, gauging the circling eagles. But she spared the wizard a grin. “By my reckoning you’re a hundred and forty,” she said. “Just thought I’d ask.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Minx.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It was probably, Ithrazel calculated, another three miles to the shoulder of the mountain where Clea’s friend Graywillow waited for them. Three miles that they could never have done in bird-free darkness, or, he estimated, had Hamo been burdened with an injured man’s weight. Only the last half-mile or so was meadow, roughly slanting and knee-deep in dry mountain grass, and by the time they reached it Ithrazel was trembling with exhaustion. The smoke of the village rose beyond the trees. Goats and sheep scattered, and a boy of eight or nine stared at them in shock from a little hillock at the far end. Ithrazel felt a curious pang of regret that he’d never see the village itself, the place from which his young friends had come all down the long years.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Were they a part of this world, like the birds? Was there anything else here, any cities, any trade, anything beyond scrabbling for the existence that the boys had from time to time described to him? Raiding the next village for stolen sheep, being raided over blood-feuds and women?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The birds fell upon them like a deadly plague, shrieking, gouging with their beaks, buffeting with their wings. At the top of the meadow, the girl cut them both branches from the stoutest plants she could find—drought-twisted acacia more like brooms than staves. The House of Stylachos, Ithrazel guessed, once the greatest among the merchants, were probably assassins these days. "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Not that they haven’t always been that")]), _vm._v(" …")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Blood ran from his torn shoulder and back where he wasn’t quick enough to fend off the eagles. He wondered if those cuts would heal come night. It was good to be able to hit back, wonderful to see Clea get in a good blow now and then and send another one of those filthy brutes screaming and bleeding to the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("More of them came down as the three fugitives crossed the open grassland, thick in the sky as monstrous blackflies. At the bottom of the meadow was a hillock, where a clump of bedraggled fig trees marked a spring. In their shade Ithrazel saw another girl get to her feet. Patchy sunlight glinted blindingly on glass, a halo of fire around her, and like the wash of heat from a kiln-door he felt it, the glittering whisper of magic in the air.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The girl stretched out her hands …")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Damn it you fool, DON’T!” Ithrazel halted in his tracks, shouted at the top of his lungs.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Her concentration broken, the girl stepped back and the spell—probably to drive the birds away—dissolved: "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The gods only know what it would have actually done!")]), _vm._v(" He yelled, “We’re in a different world, you idiot!” and turned to smash his raggedy branch of acacia at the eagle that slashed and dove at him, eight feet of wings thrashing at his head and face.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Clea called out, “Torches!” and the girl in the grove scrambled to gather and light sticks of firewood, while the fugitives raced the final hundred feet. Ithrazel stumbled. Hamo caught him under the arms and half dragged him to a little clearing among the fig trees, where three mirrors had been set up and a Gate-Sigil had been drawn on the ground. Clea grabbed a burning brand from the girl—Graywillow, Clea had called her, a few years older than Clea, clothed in the white robes of the Goddess Nyellin’s order, dark brown hair braided down past her hips—and strode out among the birds, trailing smoke and flame.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The shepherd Hamo dumped Ithrazel to the ground beside the girl, caught up another torch, and sprang to Clea’s side.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The birds retreated, screaming. Ithrazel pressed his hand to his side, muscles long unused cramping horribly, and wondered if it were possible to vomit when one hadn’t eaten anything in seventy-five years …")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Here.” Graywillow knelt beside him, offered him a water-bottle. Only when he’d drunk did she draw back a little, as if only just realizing who this ragged little man in his bloodied clothing was or had to be. Staring in shock. In horror.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("The dreams were true, then")]), _vm._v(" …")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Not that he had ever doubted. But there had been mornings on his rock when he’d hoped.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Gruffly, he snarled, “It’s me, all right. Don’t gawp at me as if I were a monster—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("With hasty obedience she turned her eyes aside. Dark eyes, like a Telmayrian, though she had the cheekbones of a Loghri.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What the hell’s all this?” He jerked a hand at the mirrors, the sigil.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The Gate,” she whispered. “The Corridor of Mirrors … I have to help them.” She looked swiftly back at Clea and Hamo.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Don’t be an imbecile. This is a different world. You have no idea what you’re sourcing your magic from. None of the gods you know have power here. Your bird-spell could open a chasm that could swallow us all, or could summon every mouse for a hundred miles around, or smite us all with leprosy—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But if we’re in another world—” The velvet-brown eyes were wide with panic. “What’s happening in our own shouldn’t be happening here. With magic,” she explained, seeing his eyes, in their turn, go blank with puzzlement and shock. “With magic changing—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Magic "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("WHAT")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Clea sprang up the hillock as the birds drew back, her forehead bleeding from a claw-gash. “Take the spell off him,” she said, with a fast glance behind her at Hamo, who was faithfully guarding her back. “Now, quickly—Lord Ithrazel’s right, we can’t use magic against the birds, we’re lucky the spell you put on Hamo worked. We have to flee. I’m sorry—I wanted to say goodbye to him—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You can’t.” The young Sister got quickly to her feet.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Clea stared at her, appalled. “Can’t what?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I thought you knew.” The girl’s gentle eyes filled now with tears. “You can’t undo a love spell, Clea. You can’t take it off like a blindfold. It has to wear off, like love does …”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Or doesn’t,” said Ithrazel grimly. “As the case may be.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The girls looked at each other, then back at him: "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Gods, if you tallied their years together in a pile, they still wouldn’t equal my daughter’s age when last I saw her")]), _vm._v(" …")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Leave the poor bastard here, then,” he advised sarcastically. “You’re never going to have to see him again. The birds should go away once I’m gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The last of the flock had risen higher in the air, circling, screaming defiance down at the young man with his torch. Hamo came running back to the others, handsome face earnest. “That’s done them,” he panted. “Lady Graywillow can open the road, we can be gone—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I can’t take you,” said Clea, and Ithrazel observed—with a combination of wrenching pity and bitter satisfaction that this bossy tomboy was being forced to admit a miscalculation ("), _c('span', {
    staticClass: "ital"
  }, [_vm._v("And what the hell did she THINK was going to happen?")]), _vm._v(")—the expression of shock, of heart-broken grief, that swept Hamo’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Hamo—” Clea stepped toward him, reached for his hand, which he pulled from her, as if her very touch would lacerate him as the birds could not.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’m sorry. I can’t take you away from your family, from your village—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The young man whispered, “My lady—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("And don’t you dare, don’t you DARE tell him he loves you because you got your White-Sister friend to slap him with a spell because you needed his services.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Don’t take from him even what he has")]), _vm._v(" …")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Ithrazel got to his feet, caught Clea’s arm when she looked as if she were about to do exactly that: stammer explanations, beg absolution, say she hadn’t meant any harm. He held out his hand to the young man, said gruffly, “The lady is right, Hamo. Your family needs you. Your people need you. Thank you—eternally—for what you’ve done. Not just for helping her to get me down from there … Thank you for coming up to the crag in the first place, all those years ago. For giving me water. For letting me know I wasn’t alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The young man’s blue eyes flooded with tears. Went from Ithrazel’s face to Clea’s, begging.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Ithrazel said, “We must go, before the birds come back. They’ll disperse once I’m gone—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Gods of mercy, PLEASE make that true. Don’t let it be that our flight’s going to leave him in the lurch.")]), _vm._v(" …")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But of course there was no way of knowing, once they passed beyond the sigil and into the Corridor of Mirrors, whatever the hell THAT was …")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Hamo only shook his head. He looked stunned, as if this were the last thing on the earth that he expected, to be deserted by the woman he had taken for the queen of his heart and life. Ithrazel caught him in a swift, rough embrace, like a son …")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Seventy-five years. That means all my children are dead.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Not only my son")]), _vm._v(" …")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He wrenched his mind from that new abyss, made himself say, “Thank you. Forever. Thank you, my boy.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Turning, he caught Clea by the arm, shoved her in the direction of the sigil, beside which Graywillow stood in an agony of compassion and uncertainty. “Open it,” he commanded. “Let’s don’t draw this out …”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She turned obediently to the sigil, raised her hands. The hot tingle of magic filled the air, mixing with Hamo’s whispered protest, “My lady—” and the harsh screams of the birds.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("And let’s hope the spell to open the gate and get us back to our own world works properly in this one.")]), _vm._v(" …")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce13c142","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IronPrincess-5.vue
// module id = 78
// module chunks = 0